import { ZENDESK_CHECK_INTERVAL, ZENDESK_CHECK_LIMIT, SUPPORT_CHAT_TAG, SUPPORT_CHAT_BLACKLIST } from 'constants/chat';

export const MAX_NUM_CHECKS = ZENDESK_CHECK_LIMIT / ZENDESK_CHECK_INTERVAL;

export const isSupportChatRoute = route =>
  !SUPPORT_CHAT_BLACKLIST.some(blacklistRoute => route.startsWith(blacklistRoute));

// To configure support chat, we need to poll for it since it is injected by google tag manager
// There is a roadmap item to move chat out of GTM and handle everything in this codebase, so the polling method should not be needed long term
export const setupSupportChat = () => {
  let numChecks = 0;

  const timer = setInterval(() => {
    const zendeskChat = window?.$zopim?.livechat;
    if (zendeskChat) {
      zendeskChat.addTags(SUPPORT_CHAT_TAG);
      clearInterval(timer);
    }

    numChecks += 1;
    if (numChecks === MAX_NUM_CHECKS) {
      clearInterval(timer);
    }
  }, ZENDESK_CHECK_INTERVAL);
};
